module.exports = __webpack_public_path__ + "img/cooperativeMedia11.0aa3751b.png";